import * as React from "react";
import { Link } from "react-router-dom";
import { Row, Col, InputGroup, Button, Modal } from "react-bootstrap";
import Modal4CreateAlert from "../../components/modals/createAlert";
import {
  AlertIcon,
  DeleteWarningIcon,
  QuickAlertIcon,
  SearchIcon,
} from "../../components/ui/icons";
import TableView from "../../components/tableView";
import {
  MIMO_GROUP_ID,
  routes,
  Status,
  TABLE_RENDERING_MODES,
} from "../../common/constants";
import useAlerts from "./useAlerts";
import DebouncedInput from "../../components/tableView/debouncedInput";
import { usePermissions } from "../../customHooks/usePermissions";

import "./alerts.scss";
import { useDispatch } from "react-redux";
import useNotification from "../../components/notification/useNotification";
import { alertAction } from "../dashboard/quickAlertsSlice";
import { isSuccessResponse } from "../../common/utils";
import { sendDasAlert } from "./dasAlertSlice";
import { fetchAlertsData } from "./listAlertsSlice";
import SendAlertConfirmationModal from "./quickAlerts/sendAlertConfirmation";



const EMPTY_EXPANDED_STATE = {};

const Alerts = () => {
  const [showDasModal, setShowDasModal] = React.useState(false);
  const { hasPermissions } = usePermissions();
  const {
    alertsTableData,
    alertsColumns,
    globalFilter,
    setGlobalFilter,
    refreshAlerts,
    noDataMessage,
    newlyCreatedAlertId,
    handleAlertActions,
    showModal,
    isMimoAccount,
    columnFilters,
    setColumnFilters,
    pageIndex,
    pageSize,
    setPageIndex,
    setPageSize,
    totalCount,
    setTotalCount,
    listApprovalApiStatus,
    approvalAlertsCount,
    handleGlobalFilterChange,
    handleColumnFiltersChange,
    endAlertDialogState,
    handleCloseEndAlertDialog,
    handleConfirmEndAlert,
    deleteAlertDialogState,
handleCloseDeleteAlertDialog,
handleConfirmDeleteAlert,
failedDevicesDialogState,
handleCloseFailedDevicesDialog,
resetExpandedRowsKey,
  } = useAlerts();

  const handleOpenDasModal = () => {
    setShowDasModal(true);
  };

  const handleConfirmDasSend = (selectedGroups) => {
    setShowDasModal(false);

    const payload = {
      selectedGroups: selectedGroups,
    };

    dispatch(sendDasAlert(payload)).then((response) => {
      if (isSuccessResponse(response.payload)) {
        dispatch(fetchAlertsData({ pageIndex: 0, pageSize: 10 }));
        showSuccessNotification(response.payload.message);
      } else {
        showWarningNotification(response.payload || "Failed to send DAS Alert");
      }
    });
  };

  const showCreateAlertButton = () => {
    return (
      <Button onClick={showModal}>
        <AlertIcon />
        <span>Create Alert</span>
      </Button>
    );
  };

  const { showSuccessNotification, showWarningNotification } =
    useNotification();

  const dispatch: any = useDispatch();
  const handleQuickAlerts = (command) => {
    const payload = command;
    dispatch(alertAction(payload)).then((response) => {
      if (isSuccessResponse(response.payload)) {
        showSuccessNotification(response.payload.message);
      } else {
        showWarningNotification(response.payload.response.data.message);
      }
    });
  };
  const EVACUATE_MSG =
    "Evacuation Emergency:\nThere is an Emergency in the building!\nPlease evacuate the building immediately per your evacuation plan!";
  const STAY_MSG =
    "Stay in Place Emergency:\nThere is an Emergency in the building that requires you to stay in place\nStay in classrooms and lock the doors!";
  const ALL_CLEAR_MSG =
    "All Clear Notice:\nEverything is back to Normal.\nPlease go back to your normal operation.";

  return (
    <div className="alerts-container">
      <Row>
        <Col sm={12}>
          <div className="alerts-header">
            <div className="heading">
              <h1>Alerts</h1>
            </div>
            <div className="alerts-input">
              <div className="alerts-search-input">
                <InputGroup>
                  <DebouncedInput
                    value={globalFilter ?? ""}
                    onChange={(value) =>
                      handleGlobalFilterChange(String(value))
                    }
                    placeholder="Search for Alert..."
                    aria-label="Recipient's username"
                    aria-describedby="alerts-search"
                  />
                  <InputGroup.Text id="alerts-search">
                    <SearchIcon />
                  </InputGroup.Text>
                </InputGroup>
              </div>
              {hasPermissions("user.delete") && (
                <div className="create-quick-alerts-btn">
                  <Link to={routes.quickAlerts}>
                    <Button>
                      <QuickAlertIcon />
                      <span> Quick Alerts</span>
                    </Button>
                  </Link>
                </div>
              )}
              {hasPermissions("user.delete") && (
                <div className="alerts-approval-btn">
                  <Link to={routes.alertsApproval}>
                    <Button>
                      Alerts Needing Approval{" "}
                      <span className="notification">
                        {listApprovalApiStatus === Status.PENDING ? (
                          <span className="mini-loader"></span>
                        ) : (
                          approvalAlertsCount
                        )}
                      </span>
                    </Button>
                  </Link>
                </div>
              )}
              <div className="create-alerts-btn">
                {hasPermissions("user.delete") && showCreateAlertButton()}
              </div>
              <div className="create-alerts-btn">
                {isMimoAccount && (
                  <Button onClick={handleOpenDasModal}>Send DAS Alert</Button>
                )}
              </div>
            </div>
          </div>
        </Col>

        <Col sm={12}>
          <div className="alerts-header alerts-action-header">
            <div className="heading">
              <h1>Alerts actions</h1>
            </div>
            <div className="alerts-input">
              {/* {isMimoAccount && (<div className='create-alerts-btn' style={{ textAlign: "center" }}>
                        <Button onClick={() => handleAlertActions("off")} style={{ display: "block" }}>
                           Off
                        </Button>
                     </div>)} */}
              {isMimoAccount && (
                <div className="create-alerts-btn">
                  <Button onClick={() => handleAlertActions("up")}>
                    Less Transparent
                  </Button>
                </div>
              )}
              {isMimoAccount && (
                <div className="create-alerts-btn">
                  <Button onClick={() => handleAlertActions("down")}>
                    More Transparent
                  </Button>
                </div>
              )}
              {/* {isMimoAccount && (<div className='create-alerts-btn'>
                        <Button onClick={() => handleAlertActions("reset")} style={{ display: "block" }}>
                           Reset
                        </Button>
                     </div>)} */}

              <div className="create-alerts-btn">
                <Button
                  onClick={() => refreshAlerts()}
                  style={{ display: "block" }}
                >
                  Refresh Alerts
                </Button>
              </div>
            </div>
          </div>
        </Col>
        <Col sm={12}>
          {isMimoAccount && (
            <div className="alerts-header alerts-action-header">
              <div className="heading">
                <h1>Quick Alerts</h1>
              </div>
              <div className="alerts-input">
                {/* <div className='create-alerts-btn'>
                        <Button onClick={handleDasAlert} style={{ display: "block" }}>Send DAS Alert</Button>
                     </div>
                     <div className='create-alerts-btn'>
                        <Button onClick={() => handleQuickAlerts({alertTitle: "Evacuate", alertMessage: EVACUATE_MSG})} style={{ display: "block" }}>
                           Evacuate
                        </Button>
                     </div>
                     <div className='create-alerts-btn'>
                        <Button onClick={() => handleQuickAlerts({alertTitle: "Stay In Place", alertMessage: STAY_MSG})} style={{ display: "block" }}>
                           Stay In Place
                        </Button>
                     </div> */}
                <div className="create-alerts-btn">
                  <Button
                    onClick={() =>
                      handleQuickAlerts({
                        alertTitle: "All Clear",
                        alertMessage: ALL_CLEAR_MSG,
                      })
                    }
                    style={{ display: "block" }}
                  >
                    All Clear
                  </Button>
                </div>
              </div>
            </div>
          )}
        </Col>
        <Col className="alertContainer">
            <TableView
              data={alertsTableData}
              columns={alertsColumns}
              globalFilter={globalFilter}
              setGlobalFilter={handleGlobalFilterChange}
              noDataMessage={noDataMessage}
              newlyCreatedAlertId={newlyCreatedAlertId}
              mode={TABLE_RENDERING_MODES.SERVER_SIDE}
              totalCount={totalCount}
              pageIndex={pageIndex}
              pageSize={pageSize}
              onPaginationChange={(newPageIndex, newPageSize) => {
                setPageIndex(newPageIndex);
                setPageSize(newPageSize);
              }}
              columnFilters={columnFilters}
              onColumnFiltersChange={handleColumnFiltersChange}
              defaultExpanded={EMPTY_EXPANDED_STATE}
              resetExpandedRowsKey={resetExpandedRowsKey}
              renderFiltersAboveTable={true}
              getRowClassName={(row) =>
                [
                  row.depth > 0 ? "alert-child-row" : "alert-parent-row",
                  row.getIsExpanded() ? "alert-parent-row-expanded" : "",
                ]
                  .filter(Boolean)
                  .join(" ")
              }
            />
        </Col>
      </Row>

      {showDasModal && (
        <SendAlertConfirmationModal
          show={showDasModal}
          onCancel={() => setShowDasModal(false)}
          onConfirm={handleConfirmDasSend}
          alertTitle="DAS Emergency"
          initialGroups={[
            {
              id: MIMO_GROUP_ID,
              displayName: "Mimo Monitors",
            },
          ]}
        />
      )}

      <Modal
        show={endAlertDialogState.show}
        onHide={handleCloseEndAlertDialog}
        className="modal-container"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="delete-heading">
              <DeleteWarningIcon />
              <h1>{endAlertDialogState.actionLabel}</h1>
            </div>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>
            Are you sure you want to{" "}
            {endAlertDialogState.actionLabel.toLowerCase()} alert "
            {endAlertDialogState.alertMessage}"?
          </p>
           {endAlertDialogState.affectedGroupNames?.length > 0 && (
    <>
      <p>
        This alert would be ended for the following Groups:
      </p>

      <ul>
        {endAlertDialogState.affectedGroupNames.map((groupName) => (
          <li key={groupName}>{groupName}</li>
        ))}
      </ul>
    </>
  )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            type="button"
            className="btn-cancel"
            onClick={handleCloseEndAlertDialog}
          >
            Cancel
          </Button>

          <Button
            type="button"
            className="btn-delete"
            onClick={handleConfirmEndAlert}
          >
            {endAlertDialogState.actionLabel}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
  show={deleteAlertDialogState.show}
  onHide={handleCloseDeleteAlertDialog}
  className="modal-container"
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>
      <div className="delete-heading">
        <DeleteWarningIcon />
        <h1>Delete</h1>
      </div>
    </Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <p>
      Are you sure you want to delete alert "
      {deleteAlertDialogState.alertMessage}"? This alert would be deleted for
      following Groups:
    </p>

    <ul>
      {deleteAlertDialogState.groupNames.map((groupName) => (
        <li key={groupName}>{groupName}</li>
      ))}
    </ul>
  </Modal.Body>

  <Modal.Footer>
    <Button
      type="button"
      className="btn-cancel"
      onClick={handleCloseDeleteAlertDialog}
    >
      Cancel
    </Button>

    <Button
      type="button"
      className="btn-delete"
      onClick={handleConfirmDeleteAlert}
    >
      Delete
    </Button>
  </Modal.Footer>
</Modal>
<Modal
  show={failedDevicesDialogState.show}
  onHide={handleCloseFailedDevicesDialog}
  className="modal-container modalDenyalerts"
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>
      <div className="delete-heading">
        <DeleteWarningIcon />
        <h1>Alerts failed to send to these devices</h1>
      </div>
    </Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <span>
      {Array.isArray(failedDevicesDialogState.deviceIds) &&
        failedDevicesDialogState.deviceIds.map((deviceId) => (
          <p key={deviceId}>{deviceId}</p>
        ))}
    </span>
  </Modal.Body>

  <Modal.Footer>
    <Button
      type="button"
      className="btn-style"
      onClick={handleCloseFailedDevicesDialog}
    >
      Close
    </Button>
  </Modal.Footer>
</Modal>
      <Modal4CreateAlert />
    </div>
  );
};
export default Alerts;
